export const EXPENSE_EXAMPLES: Record<string, string[]> = {
  FUEL: ['Gas at Shell', 'Gas at Petro-Canada', 'EV charge at Flo'],
  MAINT: ['Oil change at Canadian Tire', 'New wiper blades', 'Tire rotation'],
  UPKEEP: ['Car wash', 'Interior detailing', 'Windshield washer fluid'],
  ACCESSORIES: ['Phone mount', 'USB-C cable', 'Dashcam + SD card'],
  PARKING: ['Airport staging lot', 'Downtown meter parking'],
  TOLLS: ['Highway 407 toll'],
  PHONE: ['Monthly data plan (60% business)'],
  INSURANCE: ['Rideshare endorsement fee'],
  LEASE_PAYMENT: ['Monthly vehicle lease payment'],
  LOAN_INTEREST: ['Auto loan interest (RBC)'],
  TAX_SERVICES: ['AutoTaxPilot organizer fee'],
};
